import { type FC } from "react";

import * as Styled from "./AppFooter.styles";
import { FooterBottom } from "./components/FooterBottom";
import { FooterCategoryGrid } from "./components/FooterCategoryGrid";
import { FooterLinkColumn } from "./components/FooterLinkColumn";
import { FooterNewsletter } from "./components/FooterNewsletter";
import { COMPANY_LINKS, RESOURCE_LINKS } from "./constants";
import type { IFooterCmsLink } from "./types";
import { buildFooterColumnLinks } from "./utils/buildFooterColumnLinks";

interface IAppFooterProps {
  cmsLinks?: IFooterCmsLink[];
}

export const AppFooter: FC<IAppFooterProps> = ({ cmsLinks = [] }) => {
  return (
    <Styled.Root>
      <Styled.Container maxWidth="xl">
        <Styled.TopGrid>
          <FooterNewsletter />
          <FooterCategoryGrid />
          <FooterLinkColumn
            title="Explore"
            links={buildFooterColumnLinks("explore", [], cmsLinks)}
          />
          <FooterLinkColumn
            title="Resources"
            links={buildFooterColumnLinks(
              "resources",
              RESOURCE_LINKS,
              cmsLinks
            )}
          />
          <FooterLinkColumn
            title="Company"
            links={buildFooterColumnLinks("company", COMPANY_LINKS, cmsLinks)}
          />
        </Styled.TopGrid>
        <FooterBottom />
      </Styled.Container>
    </Styled.Root>
  );
};
